export function errorCodeToCamelCase(errorCode) {
  if (!errorCode) {
    return "";
  }

  const codeErrorArray = errorCode.split(".");
  const module = codeErrorArray[0];
  const moduleError = codeErrorArray[1];

  try {
    return `${module.charAt(0).toLowerCase()}${module.slice(1)}.${moduleError
      .charAt(0)
      .toLowerCase()}${moduleError.slice(1)}`;
  } catch (error) {
    return "error.serverError";
  }
}
